// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as ApiUtils$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.mjs";
import * as ErrorUtils$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.mjs";
import * as AuthUtils$PorterinFeature from "../../../../domain/helpers/AuthUtils.mjs";
import * as CookieUtils$PorterinFeature from "../../../../../fare-estimate-v1/utils/browser/CookieUtils.mjs";
import * as AuthRepoManager$PorterinFeature from "../../../../domain/repo/AuthRepoManager.mjs";
import * as CustomErrorUtils$PorterinFeature from "../../../../../order-review/domain/helpers/CustomErrorUtils.mjs";

function initialFormState(name) {
  return {
          name: name,
          email: ""
        };
}

function onFormSubmit(output, callbacks, setResponse, set_auth_state, user, set_user, whatsapp_constent) {
  var RepoInstance = AuthRepoManager$PorterinFeature.getAuthRepo(undefined);
  var webTrackingId = CookieUtils$PorterinFeature.webTrackingIdSafely(undefined);
  var form_data_name = output.name;
  var form_data_email = output.email;
  Curry._1(set_user, {
        auth_token: undefined,
        mobile: AuthUtils$PorterinFeature.mobile(user),
        name: form_data_name,
        requirement_type: undefined,
        email: form_data_email,
        whatsapp_consent: whatsapp_constent
      });
  ApiUtils$Catalyst.handleAPIRequest((function (param) {
          return Curry._3(RepoInstance.customerSignUp, webTrackingId, AuthUtils$PorterinFeature.mobile(user), form_data_email);
        }), (function (_data) {
          Curry._1(callbacks.notifyOnSuccess, undefined);
          Curry._1(set_auth_state, (function (param) {
                  return /* SignupReqSelection */1;
                }));
        }), (function (error) {
          var match = CustomErrorUtils$PorterinFeature.getErrorEntity(error);
          var exit = 0;
          if (typeof match === "number" || match.TAG !== /* UnprocessedEntity */1) {
            exit = 1;
          } else {
            Curry._1(setResponse, (function (param) {
                    return {
                            TAG: /* Error */1,
                            _0: ErrorUtils$Catalyst.resolveError(error)
                          };
                  }));
          }
          if (exit === 1) {
            Curry._1(setResponse, (function (param) {
                    return {
                            TAG: /* Error */1,
                            _0: ErrorUtils$Catalyst.resolveError(error)
                          };
                  }));
          }
          Curry._1(callbacks.notifyOnFailure, error);
        }));
}

export {
  initialFormState ,
  onFormSubmit ,
}
/* CookieUtils-PorterinFeature Not a pure module */
